import { Alert, Breadcrumb, Button, Col, DatePicker, Drawer, Flex, Form, Input, Layout, Popconfirm, Row, Select, notification, Radio, Space, Table, Tag, theme } from 'antd';
import { FilterOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import LeaveAPI from '../../restAPI/LeaveAPI';
import { useSelector } from 'react-redux';
import moment from 'moment';
import dayjs from 'dayjs';
import FilterComponent from '../../utils/FilterComponent';

import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CommonSkeletonLoader from '../../helperComponents/CommonSkeleton';

//import data from './sampleData';
const { Search, TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Header, Footer, Sider, Content } = Layout;

export default function LeaveManagement({ props }) {
    const { companyId, token, userCompany } = useSelector(state => state.auth);
    const [open, setOpen] = useState(false);
    const [leavesData, setLeavesData] = useState([]);
    const [tempLeavesData, setTempLeavesData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [actionState, setActionState] = useState('add');
    const [endDate, setEndDate] = useState(null);
    const [comment, setComment] = useState(null);
    const [leaveBreakdownData, setLeaveBreakdownData] = useState([]);
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const [showPopconfirm, setShowPopconfirm] = useState(false);
    const [leaveForm] = Form.useForm();
    const [currentCompanyInfo, setCurrentCompanyInfo] = useState({});
    const [radioValue, setRadioValue] = useState(0);
    const [openFilter, setOpenFilter] = useState(false);
    const [filterValues, setFilterValues] = useState([]);
    const [searchInputValue, setSearchInputValue] = useState("");
    const [signatoryAvailability, setSignatoryAvailability] = useState(false);
    const [title, setTitle] = useState("");
    const [screenLoading, setScreenLoading] = useState(false)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)
    const [formValidationErrors, setFormValidationErrors] = useState([])
    const [expandedRowKeys, setExpandedRowKeys] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    useEffect(() => {
        setScreenLoading(true)
        const companyInfo = userCompany.companyData.find(company => company.companyId == companyId);
        setCurrentCompanyInfo(companyInfo);

        getLeavesData(companyInfo);
        getSignatoryAvailabilityByUserId(companyInfo);
    }, [companyId]);

    useEffect(() => {
        handleSearchFunction(searchInputValue)
        setCurrentPage(1); // Reset to page 1 when search changes
    }, [searchInputValue]);

    useEffect(() => {
        handleFilterSearchFunction(filterValues);
        setCurrentPage(1); // Reset to page 1 when filters change
    }, [filterValues])

    const showDrawer = () => {
        setOpen(true);
        setStartDate(null);
        setEndDate(null);
        setComment(null);
    };

    const onRangeChange = (dates) => {
        setLeaveBreakdownData(null);

        if (dates && dates.length === 2) {
            const start = dates[0];
            const end = dates[1];
            setStartDate(start.format('DD MMM YYYY'));
            setEndDate(end.format('DD MMM YYYY'));

            const diff = end.diff(start, 'days') + 1;

            const rows = [];
            for (let i = 0; i < diff; i++) {
                const date = start.clone().add(i, 'days');
                rows.push({
                    key: i + 1,
                    date: date.format('YYYY-MM-DD'),
                    leaveType: 'Whole Day',
                    action: i + 1
                });
            }
            setLeaveBreakdownData(rows);

        } else {
            setStartDate(null);
            setEndDate(null);
        }
    };

    const leaveBreakdowncolumns = [
        {
            title: 'Key',
            dataIndex: 'key',
            key: 'key',
            hidden: true,
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Leave Type',
            dataIndex: 'leaveType',
            key: 'leaveType',
            align: 'center',
            render: (text, record) => (
                <Select defaultValue={text} onChange={(e) => onDropDownChange(e, record)} name='leaveTypeDropdown' style={{ width: 180 }}>
                    <Option name="wholeDay" value="Whole Day">Whole Day</Option>
                    <Option name="firstHalf" value="First Half">First Half</Option>
                    <Option name="secondHalf" value="Second Half">Second Half</Option>
                </Select>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        <Button danger type="primary" onClick={() => handleDelete(record)} icon={<DeleteOutlined />} size='small' />
                    </Flex>
                </Flex>
            ),
        },
    ];

    const onDropDownChange = (e, record) => {

        const newList = leaveBreakdownData.map((item) => {
            if (item.key === record.key) {
                item.leaveType = e;
                return item;
            }
            else {
                return item;
            }
        });

        setLeaveBreakdownData(newList);
    }

    const handleDelete = (records) => {
        setLeaveBreakdownData(l => l.filter(li => li.key !== records.key));
    }

    const onCommentChange = (comment) => {
        if (comment != null) {
            setComment(comment);
        }
        else {
            setComment(null);
        }
        // Clear validation errors when user starts typing
        if (formValidationErrors.length > 0) {
            setFormValidationErrors([]);
        }
    }

    const onClose = () => {
        setOpen(false);
        setStartDate(null);
        setEndDate(null);
        setComment(null);
        setShowPopconfirm(false);
        setLeaveBreakdownData(null);
        leaveForm.resetFields();
        setActionState("add");
        setCreateButtonLoading(false);
        setFormValidationErrors([]);
    };

    const onCancel = () => {
        setStartDate(null);
        setEndDate(null);
        setComment(null);
        setLeaveBreakdownData(null);
        leaveForm.resetFields();
        setOpen(false);
        setFormValidationErrors([]);
    }

    const handleSaveClick = async (e) => {
        e.preventDefault();
        
        // Validate form before proceeding
        try {
            await leaveForm.validateFields();
            setFormValidationErrors([]);
        } catch (errorInfo) {
            setFormValidationErrors(errorInfo.errorFields || []);
            setCreateButtonLoading(false);
            // openNotificationWithIcon('error', 'Validation Error', 'Please fix the form errors before submitting.', 'bottomLeft');
            return;
        }
        
        setCreateButtonLoading(true)
        if (!signatoryAvailability) {
            // var title = "Do you want to create the leave?";
            // setTitle(title);
            // setShowPopconfirm(false);
            handleSubmit();
            return;
        }
        getSignatoryConfirmation(currentCompanyInfo);
    }

    const getSignatoryConfirmation = async (currentCompanyInfo) => {
        console.log('getSignatoryConfirmation')

        if (leaveBreakdownData?.length === 0 || leaveBreakdownData === null) {
            openNotificationWithIcon('error', 'Leave Request Failed', 'Unable to submit your leave request. Please review your details and try again.', 'bottomLeft');
        }
        else {
            const rows = [];
            leaveBreakdownData.map((rowValue) =>
                rows.push({ leaveDate: rowValue.date, leaveType: rowValue.leaveType })
            );
            const formData = { userId: currentCompanyInfo.userDetailsId, leaves: rows };

            await LeaveAPI.getSignatoryConfirmation(formData, companyId, token)
                .then((res) => {
                    if (res.status === 200) {
                        var title = "Do you want to create the leave?";
                        setTitle(title);
                        setShowPopconfirm(true);
                    } else if (res.status === 201) {
                        setTitle(res.message);
                        setShowPopconfirm(true);
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'Leave applied failed', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'Leave applied failed', `${err.message}`, 'bottomLeft');
                    }
                });
        }
    }

    const checkCompatibilityToApplyLeave = (leaveBreakdownData, tempLeavesData) => {
        if (!tempLeavesData.length) return { status: true, message: "" };
        if (!leaveBreakdownData?.length) return { status: true, message: "" };

        const hasConflict = tempLeavesData.some(singleLeave =>
            leaveBreakdownData.some(singleLeaveApply =>
                dayjs(singleLeave.leaveDate).isSame(singleLeaveApply.date)
            )
        );
        if (!hasConflict) return { status: true, message: "" };
        if (leaveBreakdownData.length > 1) {
            return {
                status: false,
                message: "You already have leave applied on some dates within your selected range. Please remove them to proceed."
            };
        }
        const existingLeaveType = tempLeavesData.find(singleLeave =>
            leaveBreakdownData.some(singleLeaveApply =>
                dayjs(singleLeave.leaveDate).isSame(singleLeaveApply.date)
            )
        )?.leaveType;
        const applyingLeaveType = leaveBreakdownData[0].leaveType;
        const conflictRules = {
            "First Half": {
                "First Half": "First Half leave is already applied for this date.",
                "Whole Day": "Full Day leave is not allowed as First Half leave is already applied."
            },
            "Second Half": {
                "Second Half": "Second Half leave is already applied for this date.",
                "Whole Day": "Whole Day leave is not allowed as Second Half leave is already applied."
            },
            "Whole Day": {
                "First Half": "First Half leave is not allowed as Full Day leave is already applied.",
                "Second Half": "Second Half leave is not allowed as Full Day leave is already applied.",
                "Whole Day": "Full Day leave is already applied for this date."
            }
        };

        return conflictRules[existingLeaveType]?.[applyingLeaveType]
            ? { status: false, message: conflictRules[existingLeaveType][applyingLeaveType] }
            : { status: true, message: "" };
    };

    const handleSubmit = async () => {
        setShowPopconfirm(false)
        // setCreateButtonLoading(false)
        if (!leaveBreakdownData || leaveBreakdownData.length === 0 || leaveBreakdownData === null) {
            openNotificationWithIcon('error', 'Leave creation failed', 'Leave creation failed', 'bottomLeft');
        }
        else {
            const rows = [];
            leaveBreakdownData.map((rowValue) =>
                rows.push({ leaveDate: rowValue.date, leaveType: rowValue.leaveType })
            );
            //const leaveSample = {userId: currentCompanyInfo.userDetailsId, leaves: rows, comment: comment, signatoryStatus: radioValue};
            const leaveSample = { userId: currentCompanyInfo.userDetailsId, leaves: rows, comment: comment, signatoryStatus: 0 }; //Task 13071
            const checkResults = checkCompatibilityToApplyLeave(leaveBreakdownData, tempLeavesData);
            if (!checkResults.status) {
                openNotificationWithIcon('error', 'Leave creation failed', `${checkResults.message}`, 'bottomLeft');
                setCreateButtonLoading(false);
                return;
            }
            if (actionState === 'add') {
                await LeaveAPI.createLeaves(leaveSample, companyId, token)
                    .then((response) => {

                        openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                        onClose();
                    })
                    .catch((err) => {
                        if (err.response) {
                            openNotificationWithIcon('error', 'Leave creation failed', `${err.response.data.message}`, 'bottomLeft');
                        } else {
                            openNotificationWithIcon('error', 'Leave creation failed', `${err.message}`, 'bottomLeft');
                        }
                    })
            }

            if (actionState === "update") {
                await LeaveAPI.updateLeaves(null, companyId, token)
                    .then((res) => {
                        openNotificationWithIcon('success', 'Successful', `Leave updated successfully`, 'bottomLeft');
                        onClose();
                    })
                    .catch((err) => {
                        if (err.response) {
                            openNotificationWithIcon('error', 'Leave update failed', `${err.response.data.message}`, 'bottomLeft');
                        } else {
                            openNotificationWithIcon('error', 'Leave update failed', `${err.message}`, 'bottomLeft');
                        }
                    })
            }
        }
        setCreateButtonLoading(false);
        getLeavesData(currentCompanyInfo);
    }

    const columns = [
        {
            title: 'Date',
            dataIndex: 'leaveDate',
            key: 'leaveDate',
        },
        {
            title: 'Leave Type',
            dataIndex: 'leaveType',
            key: 'leaveType',
        },
        {
            title: 'Alternative Signatory',
            dataIndex: 'signatoryNames',
            key: 'signatoryNames',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (_, record) => {
                const leaveDate = new Date(record.leaveDate);
                const today = new Date();

                if (leaveDate > today) {
                    return <Flex gap="small" justify="center" align="center" vertical>
                        <Flex gap="middle" wrap="wrap">
                            {/* <Button onClick={() => onEditHandler(record)} hidden type="primary" icon={<EditOutlined />} size='small' />
                                    <Button onClick={() => onViewHandler(record)} hidden icon={<EyeOutlined />} size='small' />
                                    <Button onClick={() => onDeleteHandler(record)} danger type="primary" icon={<DeleteOutlined />} size='small' /> */}
                            <Popconfirm
                                title="Do you want to delete this leave?"
                                onConfirm={() => deleteHandler(record)}
                                onCancel={() => openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft')}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button
                                    danger
                                    type="primary"
                                    icon={<DeleteOutlined />}
                                    size='small'
                                    disabled={record.status}
                                />
                            </Popconfirm>
                        </Flex>
                    </Flex>;
                } else {
                    return <></>;
                }

            },
        },
    ];

    const onEditHandler = async (record) => {
        setActionState("update");
        setOpen(true);

        const rows = [];
        rows.push({ key: record.key, date: record.date, leaveType: record.leaveType, action: record.key });
        setLeaveBreakdownData(rows);
    };

    const onDeleteHandler = (e) => {
        e.preventDefault();
        setShowPopconfirm(true);
    }

    const deleteHandler = async (record) => {

        const leaveSample = { userId: currentCompanyInfo.userDetailsId, leaveDate: record.leaveDate, leaveType: record.leaveType };

        await LeaveAPI.deleteLeaves(leaveSample, companyId, token)
            .then((res) => {
                openNotificationWithIcon('success', 'Successful', `Leave deleted successfully`, 'bottomLeft');
                onClose();
            })
            .catch((err) => {
                if (err.response) {
                    openNotificationWithIcon('error', 'Leave delete failed', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'Leave delete failed', `${err.message}`, 'bottomLeft');
                }
            });

        getLeavesData(currentCompanyInfo);
    };

    const getLeavesData = async (companyInfo) => {

        try {
            const { data } = await LeaveAPI.getLeavesByUserDetailsId(companyInfo.userDetailsId, companyId, token);
            const leaveList = data.map((rowValue, index) => {
                const date = moment(rowValue.leaveDate).format('yyyy-MM-DD');
                return ({
                    key: `${date}-${rowValue.leaveType}-${index}`,
                    leaveDate: date,
                    leaveType: rowValue.leaveType,
                    signatoryNames: rowValue.signatoryNames,
                    comment: rowValue.comment
                });
            }).sort((a, b) => new Date(a.leaveDate) - new Date(b.leaveDate));

            setLeavesData(leaveList);
            setTempLeavesData(leaveList);

        } catch (error) {
            console.log('error while fetching leave by userid : ', error);
        } finally {
            setScreenLoading(false);
        }
    };

    const getSignatoryAvailabilityByUserId = async (companyInfo) => {
        try {
            const res = await LeaveAPI.getSignatoryAvailabilityByUserId(companyInfo.userDetailsId, companyId, token);
            if (res?.data) {
                setSignatoryAvailability(res.data.value);
                if (res.data.value) {
                    setRadioValue(1);
                }
                else {
                    setRadioValue(0);
                }
            }
        } catch (err) {
            console.log("error getting signatory availability :", err.message);
        }
    };

    const options = [
        {
            label: 'Yes',
            value: 1,
        },
        {
            label: 'No',
            value: 0,
        },
    ];

    const onChangeRadio = ({ target: { value } }) => {
        setRadioValue(value);
    };

    const handleFilterDetailsChange = (value) => {
        setFilterValues(value)
    }

    const handleRemoveTag = (key) => {
        setFilterValues(prev =>
            prev.filter(item => item.key !== key)
        );
    }

    const showFilterDrawer = () => {
        setOpenFilter(true);
    };

    const onCloseFilter = () => {
        setOpenFilter(false);
    };

    // used for search filter 
    const handleSearchFunction = (value) => {
        setSearchInputValue(value);
        if (value) {
            if (filterValues.length > 0) {
                const filteredData = tempLeavesData.filter(item =>
                    (item.leaveType && item.leaveType.toLowerCase().includes(value.toLowerCase())) ||
                    (item.comment && item.comment.toLowerCase().includes(value.toLowerCase()))
                );
                setTempLeavesData(filteredData);
            }
            else {
                const filteredData = leavesData.filter(item =>
                    (item.leaveType && item.leaveType.toLowerCase().includes(value.toLowerCase())) ||
                    (item.comment && item.comment.toLowerCase().includes(value.toLowerCase()))
                );
                setTempLeavesData(filteredData);
            }
        }
        else {
            if (filterValues.length > 0) {
                const filterData = filterDataByCriteria(leavesData, filterValues);
                setTempLeavesData(filterData);
            } else {
                setTempLeavesData(leavesData);
            }
        }
    };

    // used for filter + search
    const handleFilterSearchFunction = (value) => {
        if (value) {
            if (searchInputValue?.length > 0) {
                const filteredData = leavesData.filter(item =>
                    (item.leaveType && item.leaveType.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.leaveDate && item.leaveDate.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.comment && item.comment.toLowerCase().includes(searchInputValue.toLowerCase()))
                );
                const filterData2 = filterDataByCriteria(filteredData, value);
                setTempLeavesData(filterData2);

            } else {
                const filterData = filterDataByCriteria(leavesData, value);
                setTempLeavesData(filterData);
            }
        } else {
            if (searchInputValue?.length > 0) {
                const filteredData = leavesData.filter(item =>
                    (item.leaveType && item.leaveType.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.leaveDate && item.leaveDate.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.comment && item.comment.toLowerCase().includes(searchInputValue.toLowerCase()))
                );
                setTempLeavesData(filteredData);
            } else {
                setTempLeavesData(leavesData);
            }
        }
    }

    // used for advance filter
    const filterDataByCriteria = (data, criteria) => {
        return data.filter(item => {
            return criteria.every(({ key, value }) => {
                // to-do put for status also
                if (!item[key] || !value) return false;
                const itemValue = item[key].toString().toLowerCase();
                const lowerCasePrefix = value.toLowerCase();
                return itemValue.startsWith(lowerCasePrefix);
            });
        });
    };

    // disabled date function 
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current < dayjs().add(-1, "day");
    };

    //   const handleExpand = (expanded, record) => {
    //     console.log('expanded :', expanded)
    //     console.log('record :', record)
    //     const rowIndex = tempLeavesData.findIndex(item => item.key === record.key);
    //     setExpandedRowKey(expanded ? [record.])
    //   }

    const filterTags = filterValues.filter(filterObject => filterObject.value.trim() !== "");

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            // href: '',
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Leave Management',
                        },
                        {
                            title: 'Leave',
                        },
                    ]}
                />
                <Flex justify='center' align='center' gap={12}>
                    <Flex justify='center' align='center' gap={12}>
                        <Button onClick={showFilterDrawer} icon={<FilterOutlined style={{ paddingLeft: 8, paddingRight: 8 }} />} />
                        <Search placeholder="Search" value={searchInputValue} onChange={(e) => setSearchInputValue(e.target.value)} />
                    </Flex>
                    <Button type="primary" onClick={showDrawer} >Add New</Button>
                </Flex>

            </Flex>
            <div style={{
                margin: '16px',
            }}>
                {
                    filterTags.length !== 0 &&
                    <Flex align='center' gap={12}>
                        {filterTags.map((item) => (
                            <Tag bordered={false} closable color='success' key={item?.key}
                                onClose={() => handleRemoveTag(item?.key)}
                            >
                                {item?.value}
                            </Tag>
                        ))}
                    </Flex>
                }
            </div>
            <div style={{
                margin: '16px',
                padding: 24,
                minHeight: "78svh",
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                {screenLoading ? (<>
                    <CommonSkeletonLoader />
                </>) : (<>
                    <Table
                        columns={columns}
                        dataSource={tempLeavesData}
                        scroll={{ x: 'max-content' }}
                        expandable={{
                            expandedRowRender: (record) => (
                                record.comment !== "" ?
                                    <p
                                        style={{
                                            margin: 0,
                                            maxWidth: "calc(100svw - 200px)"
                                        }}
                                    >
                                        {record.comment}
                                    </p> : ""
                            ),
                            expandedRowKeys: expandedRowKeys,
                            onExpand: (expanded, record) => {
                                if (expanded) {
                                    
                                    setExpandedRowKeys([record.key]);
                                } else {
                                    setExpandedRowKeys([]);
                                }
                            }
                        }}
                        pagination={{
                            current: currentPage,
                            pageSize,
                            onChange: (page, size) => {
                                setCurrentPage(page);
                                setPageSize(size);
                            },
                            onShowSizeChange: (current, size) => {
                                setCurrentPage(1);
                                setPageSize(size);
                            },
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            selectProps: {
                                showSearch: false,
                                inputReadOnly: true,
                                onInputKeyDown: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                onKeyDown: (e) => {
                                    // Allow only arrow keys, Enter, Escape, Tab
                                    if (!['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Tab'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }
                            }
                        }}
                    />
                </>)}
            </div>
            <Drawer title={actionState === 'add' ? "Add Leave" : "Update Leave"}
                onClose={onClose}
                open={open}
                size='large'
                // placement='bottom'
                footer={[
                    <Flex justify='flex-end' align='center' gap='large'>
                        <Button onClick={onCancel} disabled={createButtonLoading}>
                            Cancel
                        </Button>
                        <Popconfirm
                            //title={`Do you want to ${actionState === "add" ? "create" : "update"} the leave?`}
                            title={title}
                            open={showPopconfirm}
                            onConfirm={() => handleSubmit()}
                            onCancel={() => {
                                setShowPopconfirm(false)
                                setCreateButtonLoading(false)
                                openNotificationWithIcon('error', 'Abort', `${actionState === "add" ? "Create" : "Update"} cancelled`, 'bottomLeft')
                            }}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button type="primary" onClick={handleSaveClick} loading={createButtonLoading} disabled={createButtonLoading || (!startDate || !endDate) 
                                || (Array.isArray(leaveBreakdownData) && leaveBreakdownData.length === 0) 
                                // || formValidationErrors.length > 0
                                }>
                                {actionState === "add" ? "Create" : "Update"}
                            </Button>
                        </Popconfirm>
                    </Flex>
                ]
                }
            >
                <Form layout="vertical" form={leaveForm}>
                    <Form.Item label="Select Date" name="dateRange">
                        <RangePicker format="YYYY/MM/DD" disabledDate={disabledDate} onChange={onRangeChange} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label="Comment" name="comment" rules={[
                        {
                            max: 250,
                            message: 'Comment should be maximum 250 characters.'
                        },
                    ]}>
                        <TextArea defaultValue="" onChange={e => onCommentChange(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="Want to add alternative signatories ?">
                        <Radio.Group
                            onChange={onChangeRadio}
                            value={radioValue}
                            optionType="button"
                        >
                            {options.map(option => (
                                <Radio.Button
                                    key={option.value}
                                    value={option.value}
                                    //disabled={!signatoryAvailability && option.value === 1}
                                    disabled={option.value === 1}
                                >
                                    {option.label}
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </Form.Item>
                    <Table
                        columns={leaveBreakdowncolumns}
                        dataSource={leaveBreakdownData}
                        scroll={{ x: 'max-content' }}
                    />

                </Form>
            </Drawer>
            <FilterComponent
                openDrawer={openFilter}
                closeDrawer={onCloseFilter}
                data={tempLeavesData}
                handleFilterDetailsChange={handleFilterDetailsChange}
                filterValues={filterValues}
                screenName="leaveManagement"
                resetFilterValues={() => setFilterValues([])}
            />
            {contextHolder}
        </>
    )
}